import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import { styledLayout } from '@pkg/primitives';

import { tokens } from '../../tokens';

import { mainTransition, MainVariant, mainVariants } from './Main.motion';

interface StyledSoloSectionProps {
    $gutters?: boolean;
    $padded?: boolean;
}

export const MainWrapper = styled(motion.div).attrs({
    variants: mainVariants,
    initial: MainVariant.Hidden,
    animate: MainVariant.Show,
    exit: MainVariant.Hidden,
    transition: mainTransition,
})`
    ${styledLayout.fullHeightFix};
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
`;

export const StyledSoloSection = styled.div<StyledSoloSectionProps>`
    ${styledLayout.fullHeightFix};
    --solo-section-gap: ${({ $gutters }) => ($gutters ? `${tokens.spacing.loose}px` : undefined)};
    --solo-section-padding-y: ${tokens.spacing.tight}px;

    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    ${styledLayout.scrollbar({
        thumbColor: 'var(--yat_scrollbar-thumb-color)',
        trackColor: 'transparent',
    })};

    ${styledLayout.featherMask({
        featherSize: tokens.spacing.tight,
        scrollbarSize: tokens.spacing.tight / 2,
    })};

    ${({ $padded }) =>
        $padded &&
        css`
            --solo-section-padding-x: ${tokens.spacing.tight}px;

            @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
                --solo-section-padding-x: ${tokens.spacing.loose}px;
            }
        `};

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        --solo-section-padding-y: ${tokens.spacing.loose}px;
    }
`;

export const Interior = styled.div`
    display: grid;
    gap: var(--solo-section-gap);
    margin-top: auto;
    margin-bottom: auto;
    padding-top: calc(var(--solo-section-padding-y) * 3);
    padding-right: var(--solo-section-padding-x);
    padding-bottom: var(--solo-section-padding-y);
    padding-left: var(--solo-section-padding-x);
`;
